module.exports = __webpack_public_path__ + "static/img/onTheLeft.ec255e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onTheLeft.png
// module id = U+Ma
// module chunks = 23